import React from 'react';
import { ButtonComponentStyles, FeaturedContainerLayoutStyleListTypes, TextComponentLayout } from '../../utils/utils';
import Button from '../Button/button';
import TextComponent from '../TextComponent/textComponent';
import FeaturedThumbnail from './FeaturedThumbnail/featuredThumbnail';
import './featured.scss';
import PartnerLogoGrid from '../PartnersLogoGrid/partnerLogoGrid';

const FeaturedContainer = (props) => {
  const { featuredThumbnailList, featuredTextCompList, partnerLogoGrid, buttonText, featureHeading, description, buttonLinkTo } = props;
  const renderFeaturedThumbnails = ({ imageSrc, desc, linkTo }) => {
    return <FeaturedThumbnail imageSrc={imageSrc} description={desc} link={linkTo} />;
  };
  const renderFeaturedTextComponent = ({ heading, desc }) => {
    return <TextComponent description={desc} heading={heading} layoutStyle={TextComponentLayout.CENTER} />;
  };
  const renderPartnerLogoGrid = (data) => <PartnerLogoGrid gridData={data} />;
  const getContainerStyle = (style) => {
    switch (style) {
      case FeaturedContainerLayoutStyleListTypes.CENTER:
        return 'featured-container style-1';
      case FeaturedContainerLayoutStyleListTypes.LEFT:
        return 'featured-container style-2';
      case FeaturedContainerLayoutStyleListTypes.RIGHT:
        return 'featured-container style-3';
      default:
        return 'featured-container';
    }
  };
  return (
    <div className={`${getContainerStyle(FeaturedContainerLayoutStyleListTypes.CENTER)}`}>
      <div className="container">
        {(description || featureHeading) && (
          <TextComponent showIcon heading={featureHeading} description={description} layoutStyle={TextComponentLayout.CENTER} />
        )}
        {featuredThumbnailList && ('')}
        {featuredTextCompList && (
          <div className="featured-text-row">
            {featuredTextCompList.map((textComp) => (
              <div key={Math.random().toString(36).substring(7)} className="featured-text-col">
                {' '}
                {renderFeaturedTextComponent(textComp)}
              </div>
            ))}
          </div>
        )}
        {partnerLogoGrid && renderPartnerLogoGrid(partnerLogoGrid)}
        {buttonText && (
          <div className="btn-row text-center">
            <Button buttonStyle={ButtonComponentStyles.PRIMARY_OUTLINE} title={buttonText} linkTo={buttonLinkTo} />
          </div>
        )}
      </div>
    </div>
  );
};

export default FeaturedContainer;
